import { LayoutLegacy } from '@silvertours/front-legacy-entities';
import { useTranslations } from 'next-intl';
import Image, { type StaticImageData } from 'next/image';
import {
  Container,
  ImageWrapper,
  Title,
  Subtitle,
  Description,
  Wrapper,
  TopBorderWrapper,
} from './ErrorPage.styles';
import ErrorAnimation401 from './BM_401_errorsite.png';
import ErrorAnimation403 from './BM_403_errorsite.png';
import ErrorAnimation404 from './BM_404_errorsite.png';
import ErrorAnimation410 from './BM_410_errorsite.png';
import ErrorAnimation500 from './BM_500_errorsite.png';
import ErrorAnimation503 from './BM_503_errorsite.png';

export type ErrorCode = 401 | 403 | 404 | 410 | 500 | 503;

const ERROR_ANIMATIONS: Record<ErrorCode, StaticImageData> = {
  401: ErrorAnimation401,
  403: ErrorAnimation403,
  404: ErrorAnimation404,
  410: ErrorAnimation410,
  500: ErrorAnimation500,
  503: ErrorAnimation503,
};

interface IntroProps {
  statusCode?: ErrorCode;
}

const Intro = ({ statusCode = 404 }: IntroProps) => {
  const t = useTranslations('features.errorPage');

  // Codes without their own image and texts fall back to the 404 page
  const errorCode: ErrorCode =
    statusCode in ERROR_ANIMATIONS ? statusCode : 404;
  const errorImage = ERROR_ANIMATIONS[errorCode];
  const errorKey = String(errorCode) as `${ErrorCode}`;

  return (
    <TopBorderWrapper>
      <LayoutLegacy.PlainSegment>
        <Wrapper>
          <ImageWrapper>
            <Image src={errorImage} alt="" priority unoptimized />
          </ImageWrapper>
          <Container>
            <Title>{t(`${errorKey}.title`)}</Title>
            <Subtitle>{t(`${errorKey}.subtitle`)}</Subtitle>
            <Description>{t(`${errorKey}.description`)}</Description>
          </Container>
        </Wrapper>
      </LayoutLegacy.PlainSegment>
    </TopBorderWrapper>
  );
};

export { Intro };
